import { publicFileUrl } from "../utils/publicFileUrl";

export const PROVIDER_LOGO_PUBLIC_PATH = "/provider-logos";

export const PROVIDER_LOGO_FILES = {
  ADVANTAGE: "ADVANTAGE.png",
  AIA: "AIA.png",
  AIG: "AIG.png",
  ALLIANZ: "ALLIANZ.png",
  ALLIEDWORLD: "ALLIEDWORLD.png",
  ASIA: "ASIA.png",
  AXA: "AXA.png",
  AXAEB: "AXAEB.png",
  BCT: "BCT.png",
  BLUE: "BLUE.png",
  BOCLIFE: "BOCLIFE.jpeg",
  BOLTTECH: "BOLTTECH.png",
  BUPA: "BUPA.png",
  CHINALIFE: "CHINALIFE.png",
  CHUBB: "CHUBB.jpeg",
  CHUBBGI: "CHUBBGI.png",
  CIGNA: "CIGNA.png",
  CPICLIFE: "CPICLIFE.png",
  CTF: "CTF.jpeg",
  DAHSING: "DAHSING.png",
  FPI: "FPI.png",
  FTLIFE: "FTLIFE.png",
  FUBON: "FUBON.png",
  FWD: "FWD.png",
  GENERALI: "GENERALI.jpeg",
  ITA: "ITA.png",
  LIBERTY: "LIBERTY.png",
  MANULIFE: "MANULIFE.png",
  PANAMERICA: "PANAMERICA.png",
  PINGAN: "PINGAN.png",
  PRU: "PRU.png",
  QBE: "QBE.png",
  STANDARDLIFE: "STANDARDLIFE.png",
  SUNLIFE: "SUNLIFE.png",
  TAHOE: "TAHOE.png",
  TAIPING: "TAIPING.png",
  TRANSAMERICA: "TRANSAMERICA.png",
  WELLLINK: "WELLLINK.png",
  YFLIFE: "YFLIFE.png",
  ZURICH: "ZURICH.png",
};

const REGION_SUFFIXES = [
  "MACAU",
  "MACAO",
  "CHINA",
  "HONG KONG",
  "HK",
  "BERMUDA",
  "OVERSEAS",
  "ASIA",
];

const LATIN_ALIASES = [
  ["YF LIFE", "YFLIFE"],
  ["YFLIFE", "YFLIFE"],
  ["TAHOE LIFE", "TAHOE"],
  ["TAHOE", "TAHOE"],
  ["TRANSAMERICA LIFE", "TRANSAMERICA"],
  ["TRANSAMERICA", "TRANSAMERICA"],
  ["ADVANTAGE LIFE", "ADVANTAGE"],
  ["ADVANTAGE INSURANCE", "ADVANTAGE"],
  ["ADVANTAGE", "ADVANTAGE"],
  ["INVESTORS TRUST", "ITA"],
  ["ITA", "ITA"],
  ["CHINA LIFE", "CHINALIFE"],
  ["CHINALIFE", "CHINALIFE"],
  ["PAN AMERICAN", "PANAMERICA"],
  ["PAN AMERICA", "PANAMERICA"],
  ["PANAMERICA", "PANAMERICA"],
  ["HENG AN STANDARD LIFE", "STANDARDLIFE"],
  ["HENG AN STANDARD", "STANDARDLIFE"],
  ["HENG AN", "STANDARDLIFE"],
  ["STANDARD LIFE", "STANDARDLIFE"],
  ["STANDARDLIFE", "STANDARDLIFE"],
  ["CHINA PACIFIC", "CPICLIFE"],
  ["CPIC LIFE", "CPICLIFE"],
  ["CPICLIFE", "CPICLIFE"],
  ["CHINA TAIPING", "TAIPING"],
  ["TAIPING", "TAIPING"],
  ["WELL LINK LIFE", "WELLLINK"],
  ["WELL LINK", "WELLLINK"],
  ["WELLLINK", "WELLLINK"],
  ["BOC GROUP LIFE", "BOCLIFE"],
  ["BOC GROUP", "BOCLIFE"],
  ["BOC LIFE", "BOCLIFE"],
  ["BOCGROUP", "BOCLIFE"],
  ["BOCLIFE", "BOCLIFE"],
  ["CHOW TAI FOOK LIFE", "CTF"],
  ["CHOW TAI FOOK", "CTF"],
  ["CTF LIFE", "CTF"],
  ["SUN LIFE", "SUNLIFE"],
  ["SUNLIFE", "SUNLIFE"],
  ["FWD LIFE", "FWD"],
  ["FT LIFE", "FTLIFE"],
  ["FTLIFE", "FTLIFE"],
  ["PING AN", "PINGAN"],
  ["PINGAN", "PINGAN"],
  ["PRUDENTIAL", "PRU"],
  ["TOKIO MARINE", "TOKIOMARINE"],
  ["ALLIED WORLD", "ALLIEDWORLD"],
  ["LIBERTY INTERNATIONAL", "LIBERTY"],
  ["LIBERTY INSURANCE", "LIBERTY"],
  ["MANULIFE", "MANULIFE"],
  ["GENERALI", "GENERALI"],
  ["CHUBB", "CHUBB"],
  ["CIGNA", "CIGNA"],
  ["ZURICH", "ZURICH"],
  ["BUPA", "BUPA"],
  ["BLUE", "BLUE"],
  ["AIA", "AIA"],
  ["AXA", "AXA"],
  ["FWD", "FWD"],
  ["FUBON", "FUBON"],
  ["FPI", "FPI"],
  ["QBE", "QBE"],
  ["AIG", "AIG"],
  ["BCT", "BCT"],
  ["CTF", "CTF"],
  ["PRU", "PRU"],
  ["BOLTTECH", "BOLTTECH"],
  ["ALLIANZ", "ALLIANZ"],
  ["DAHSING", "DAHSING"],
  ["DAH SING", "DAHSING"],
];

const CHINESE_ALIASES = [
  ["中国人寿", "CHINALIFE"],
  ["中國人壽", "CHINALIFE"],
  ["万通", "YFLIFE"],
  ["萬通", "YFLIFE"],
  ["泰禾", "TAHOE"],
  ["全美", "TRANSAMERICA"],
  ["中国太平洋", "CPICLIFE"],
  ["中國太平洋", "CPICLIFE"],
  ["中国太平", "TAIPING"],
  ["中國太平", "TAIPING"],
  ["恒安标准", "STANDARDLIFE"],
  ["恒安標準", "STANDARDLIFE"],
  ["立橋人寿", "WELLLINK"],
  ["立橋人壽", "WELLLINK"],
  ["立桥人寿", "WELLLINK"],
  ["周大福", "CTF"],
  ["中银人寿", "BOCLIFE"],
  ["中銀人壽", "BOCLIFE"],
  ["友邦", "AIA"],
  ["安盛", "AXA"],
  ["微蓝", "BLUE"],
  ["微藍", "BLUE"],
  ["保柏", "BUPA"],
  ["安达", "CHUBB"],
  ["安達", "CHUBB"],
  ["信诺", "CIGNA"],
  ["信諾", "CIGNA"],
  ["富卫", "FWD"],
  ["富衛", "FWD"],
  ["忠意", "GENERALI"],
  ["宏利", "MANULIFE"],
  ["保誠", "PRU"],
  ["保诚", "PRU"],
  ["永明", "SUNLIFE"],
  ["苏黎世", "ZURICH"],
  ["蘇黎世", "ZURICH"],
  ["富邦", "FUBON"],
];

export const normalizeProviderLogoKey = (value) =>
  String(value ?? "")
    .normalize("NFKC")
    .toUpperCase()
    .replace(/&/g, " AND ")
    .replace(/[_./\\-]+/g, " ")
    .replace(/[^\p{L}\p{N}\s]+/gu, " ")
    .replace(/\s+/g, " ")
    .trim();

const stripRegionSuffix = (value) => {
  let current = normalizeProviderLogoKey(value);
  let changed = true;
  while (changed && current) {
    changed = false;
    for (const suffix of REGION_SUFFIXES) {
      const re = new RegExp(`(?:^|\\s)${suffix}$`);
      if (current !== suffix && re.test(current)) {
        current = current.replace(re, "").trim();
        changed = true;
      }
    }
  }
  return current;
};

const chineseStartsWithBrand = (text, brand) => {
  const value = String(text || "").trim();
  if (!value.startsWith(brand)) return false;
  const rest = value.slice(brand.length);
  if (!rest) return true;
  return /^[\s\-（(人寿人壽保險保险]/.test(rest);
};

const providerTextFields = (provider = {}) => [
  provider.code,
  provider.insurerCode,
  provider.shortName,
  provider.name,
  provider.cname,
];

const isAssetManagerNotInsurer = (provider = {}) =>
  /愷明|凯明/.test(
    [provider.cname, provider.name, provider.shortName].join(" ")
  );

const matchLatinAlias = (value) => {
  const normalized = stripRegionSuffix(value);
  if (!normalized) return "";
  for (const [alias, key] of LATIN_ALIASES) {
    if (normalized === alias) return key;
  }
  return "";
};

const matchChineseAlias = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";
  for (const [alias, key] of CHINESE_ALIASES) {
    if (chineseStartsWithBrand(text, alias)) return key;
  }
  return "";
};

export const matchProviderLogoKey = (provider = {}) => {
  if (!provider || isAssetManagerNotInsurer(provider)) return "";

  for (const field of providerTextFields(provider)) {
    const latin = matchLatinAlias(field);
    if (latin) return latin;
  }

  for (const field of providerTextFields(provider)) {
    const chinese = matchChineseAlias(field);
    if (chinese) return chinese;
  }

  return "";
};

export const defaultProviderLogoPath = (provider) => {
  const key = matchProviderLogoKey(provider);
  const file = key ? PROVIDER_LOGO_FILES[key] : "";
  return file ? `${PROVIDER_LOGO_PUBLIC_PATH}/${file}` : "";
};

export const providerLogoSrc = (provider) => {
  if (provider?.image) return publicFileUrl(provider.image);
  const fallback = defaultProviderLogoPath(provider);
  return fallback ? publicFileUrl(fallback) : "";
};
